<t4-header icon="glyphicon-stats"></t4-header>
<t4-report reportId="9EB1814A-926A-4EE7-833A-17B39CAD6EA5"></t4-report>
<t4-container title="{{ 'Turbo.Common.Reports.lblFleetAvailabilityData' | translate : 'Fleet availablility' }}">
  <t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
  <t4-data-table #tbl reportName="FleetAvailabilityReport" headline="" [parameters]="{from: fromDate, to:toDate}" [autoGenerateColumns]="false" matSort [filterFields]="['RegNo', 'LocationName', 'GroupName', 'Country']">
    <ng-container matColumnDef="RegNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Trailer</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{row.RegNo}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="LocationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px;">Location</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 180px;">{{row.LocationName}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="GroupName">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 180px;">Group</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 180px;">{{row.GroupName}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Country">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Country</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{row.Country}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Availability">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px;">Availability</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 120px;">{{row.Availability | percent}}</mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
